/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Search_EverywhereInputs */

const cs_documents_search_everywhere = /** @type {(inputs: Documents_Search_EverywhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všude`)
};

const en_documents_search_everywhere = /** @type {(inputs: Documents_Search_EverywhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everywhere`)
};

/**
* | output |
* | --- |
* | "Everywhere" |
*
* @param {Documents_Search_EverywhereInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_search_everywhere = /** @type {((inputs?: Documents_Search_EverywhereInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Search_EverywhereInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_search_everywhere(inputs)
	return cs_documents_search_everywhere(inputs)
});